/* ============================================================
   Popup offre de bienvenue — JavaScript vanilla minimal (V2.2).
   Inchangé : whitelist côté Liquid, N s OU N % de scroll (écouteur
   passif retiré après déclenchement), une seule auto-ouverture par
   session, fermeture = plus d'auto-ouverture, deux vues (formulaire /
   code), pilule "Mon code", Escape, piège et restitution du focus,
   verrouillage du scroll, coexistence avec le bandeau cookies (observé,
   jamais modifié).
   V2.2 : cycle d'ouverture garanti pour le fondu — retrait de hidden,
   reflow forcé (état initial calculé), puis classe d'ouverture dans la
   frame suivante ; hidden n'est posé qu'après la transition de fermeture.
   V2.3 : refus mémorisé 21 jours et code persistant (localStorage, repli
   sessionStorage) ; pas d'ouverture pendant la recherche ; retour de
   formulaire attribué au popup seulement s'il vient de son formulaire.
   P3 : verrou du scroll commun (classe sur <html>, comme le menu, la
   recherche et le panier) ; pas d'ouverture pendant le menu mobile, teaser
   et pilule masqués tant que les boutons du héros traversent leur zone.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-tp-promo]');
  if (!root) return;

  /* Mémoire du popup (stockage navigateur purement fonctionnel, aucune donnée
     personnelle) :
     - KEY_STATE (session = onglet) : "shown" | "dismissed" → une seule
       auto-ouverture par session ;
     - KEY_DISMISSED (persistant) : horodatage du refus (« Non merci », fond,
       Échap) → plus d'auto-ouverture pendant DISMISS_DAYS jours, tous onglets
       et visites confondus ; au-delà, l'entrée est effacée et le popup peut
       revenir ;
     - KEY_CODE (persistant) : "1" après inscription réussie → pilule
       « Mon code » retrouvable d'une visite à l'autre, plus d'auto-ouverture ;
     - KEY_SUBMIT (session) : horodatage de l'envoi du formulaire du popup
       (voir « Retour du formulaire »).
     Persistant = localStorage ; s'il est indisponible (navigation privée
     stricte, stockage bloqué), repli sur sessionStorage, sinon rien
     (dégradation silencieuse : comportement par onglet). */
  var KEY_STATE = 'tp_promo_v1';
  var KEY_DISMISSED = 'tp_promo_dismissed_v1';
  var KEY_CODE = 'tp_promo_code_v1';
  var KEY_SUBMIT = 'tp_promo_submit_v1';
  var DISMISS_DAYS = 21;
  var DISMISS_MS = DISMISS_DAYS * 24 * 60 * 60 * 1000;
  var SUBMIT_MAX_MS = 10 * 60 * 1000;

  function storage(kind) {
    try {
      var s = window[kind];
      s.setItem('tp_promo_test', '1');
      s.removeItem('tp_promo_test');
      return s;
    } catch (e) { return null; }
  }
  var sessionStore = storage('sessionStorage');
  var persistStore = storage('localStorage') || sessionStore;

  function getItem(k, persist) { var s = persist ? persistStore : sessionStore; try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function setItem(k, v, persist) { var s = persist ? persistStore : sessionStore; try { if (s) s.setItem(k, v); } catch (e) { /* stockage plein / bloqué : simple dégradation */ } }
  function removeItem(k, persist) { var s = persist ? persistStore : sessionStore; try { if (s) s.removeItem(k); } catch (e) { /* idem */ } }

  /* Refus récent (< DISMISS_DAYS jours) ? Une date absente, illisible, future
     ou expirée est effacée et vaut « pas de refus ». */
  function dismissedRecently() {
    var t = parseInt(getItem(KEY_DISMISSED, true), 10);
    var age = Date.now() - t;
    if (t > 0 && age >= 0 && age < DISMISS_MS) return true;
    removeItem(KEY_DISMISSED, true);
    return false;
  }

  var dialog = root.querySelector('.tp-promo__dialog');
  var closers = root.querySelectorAll('[data-tp-promo-close]');
  var views = {
    form: root.querySelector('[data-tp-promo-view="form"]'),
    success: root.querySelector('[data-tp-promo-view="success"]')
  };
  var teaser = document.getElementById('tpPromoTeaser');
  var codePill = document.getElementById('tpPromoCodePill');
  var copyBtn = root.querySelector('[data-tp-promo-copy]');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CLOSE_MS = 180;
  var COOKIE_GRACE_MS = 1500;
  var isOpen = false, closing = false, lastFocus = null;

  /* ---------- Verrouillage du scroll ----------
     Verrou commun à toutes les surfaces superposées : classe sur <html>
     (overflow: hidden, place de la barre classique gardée, toudoupet-header.css). La page ne
     bouge pas, rien à restaurer. L'ancien verrou (body en position fixe)
     faisait sortir le header collant de l'écran derrière le voile. */
  function lockScroll() { document.documentElement.classList.add('tp-promo-locked'); }
  function unlockScroll() { document.documentElement.classList.remove('tp-promo-locked'); }

  /* ---------- Rappels (teaser / pilule) ---------- */
  function hasCode() { return getItem(KEY_CODE, true) === '1'; }

  function refreshReminders() {
    if (isOpen) {
      if (teaser) teaser.hidden = true;
      if (codePill) codePill.hidden = true;
      return;
    }
    if (hasCode()) {
      if (teaser) teaser.hidden = true;
      if (codePill) codePill.hidden = false;
    } else {
      if (codePill) codePill.hidden = true;
      if (teaser) teaser.hidden = false;
    }
  }

  function showView(name) {
    if (views.form) views.form.hidden = name !== 'form';
    if (views.success) views.success.hidden = name !== 'success';
    dialog.setAttribute('aria-labelledby', name === 'success' ? 'tpPromoTitleSuccess' : 'tpPromoTitle');
  }

  /* ---------- Accessibilité ---------- */
  function focusables() {
    return Array.prototype.slice.call(
      dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function cartDrawerIsOpen() {
    var drawer = document.getElementById('tpCartDrawer');
    return !!(drawer && (drawer.classList.contains('is-open') || drawer.getAttribute('aria-hidden') === 'false'));
  }

  /* Fenêtre de recherche du header ouverte (toudoupet-search.js) ? */
  function searchIsOpen() {
    var modal = document.getElementById('tpSearchModal');
    return !!(modal && !modal.hidden);
  }

  /* Menu mobile ouvert (toudoupet-header.js) ? */
  function menuIsOpen() { return document.documentElement.classList.contains('tp-menu-open'); }

  /* Une seule couche à la fois : panier, recherche ou menu mobile ouverts →
     pas de popup (une seule Échap, un seul piège de focus). */
  function otherLayerOpen() { return cartDrawerIsOpen() || searchIsOpen() || menuIsOpen(); }

  /* ---------- Ouverture / fermeture ---------- */
  function open(view) {
    if (isOpen || closing) return;
    isOpen = true;
    showView(view || 'form');
    lastFocus = document.activeElement;
    lockScroll();
    refreshReminders();

    /* Cycle garanti : 1) retirer hidden, 2) forcer le calcul de l'état
       initial (opacité 0), 3) frame suivante : classe d'ouverture.
       Sans le reflow, un navigateur peut regrouper les deux changements
       et sauter le fondu. */
    root.classList.remove('is-closing');
    root.hidden = false;
    void root.offsetWidth;
    if (reduceMotion) {
      root.classList.add('is-open');
    } else {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { root.classList.add('is-open'); });
      });
    }

    var target = (view === 'success')
      ? root.querySelector('[data-tp-promo-copy]')
      : root.querySelector('input[type="email"]');
    if (!target) target = root.querySelector('.tp-promo__close');
    if (target) window.setTimeout(function () { target.focus({ preventScroll: true }); }, reduceMotion ? 0 : 60);
    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!isOpen || closing) return;
    closing = true;
    document.removeEventListener('keydown', onKey);
    setItem(KEY_STATE, 'dismissed');
    if (!hasCode()) setItem(KEY_DISMISSED, String(Date.now()), true);
    var finish = function () {
      root.classList.remove('is-open', 'is-closing');
      root.hidden = true; /* seulement après la transition de fermeture */
      isOpen = false;
      closing = false;
      unlockScroll();
      refreshReminders();
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    };
    if (reduceMotion) { finish(); return; }
    root.classList.add('is-closing');
    root.classList.remove('is-open');
    window.setTimeout(finish, CLOSE_MS + 20);
  }

  Array.prototype.forEach.call(closers, function (el) { el.addEventListener('click', close); });
  if (teaser) teaser.addEventListener('click', function () { if (!otherLayerOpen()) open('form'); });
  if (codePill) codePill.addEventListener('click', function () { if (!otherLayerOpen()) open('success'); });

  /* D10 — teaser et pilule (fixes, bas gauche) ne recouvrent jamais les boutons
     du héros de l'accueil : masqués (classe is-yielding) tant que le groupe de
     boutons traverse la bande basse de l'écran où ils s'affichent (96 px, zone
     sûre comprise). Bande recalculée au redimensionnement. */
  var heroCtas = document.querySelector('.tp-hero__cta-group');
  if (heroCtas && (teaser || codePill) && 'IntersectionObserver' in window) {
    var heroIo = null, heroTimer = null;
    var watchHero = function () {
      if (heroIo) heroIo.disconnect();
      heroIo = new IntersectionObserver(function (entries) {
        var hit = entries[entries.length - 1].isIntersecting;
        if (teaser) teaser.classList.toggle('is-yielding', hit);
        if (codePill) codePill.classList.toggle('is-yielding', hit);
      }, { rootMargin: Math.min(0, 96 - window.innerHeight) + 'px 0px 0px 0px' });
      heroIo.observe(heroCtas);
    };
    watchHero();
    window.addEventListener('resize', function () { window.clearTimeout(heroTimer); heroTimer = window.setTimeout(watchHero, 150); }, { passive: true });
  }

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = document.getElementById('tpPromoCode');
      if (!code || !navigator.clipboard) return;
      navigator.clipboard.writeText(code.textContent.trim()).then(function () {
        copyBtn.textContent = copyBtn.dataset.labelDone || 'Copié';
        window.setTimeout(function () { copyBtn.textContent = copyBtn.dataset.label || 'Copier'; }, 1800);
      }).catch(function () { /* sans presse-papiers : le code reste visible */ });
    });
  }

  /* Le panier qui s'ouvre prime toujours sur le popup. */
  var cartBtn = document.getElementById('tpCartIconBtn');
  if (cartBtn) cartBtn.addEventListener('click', function () { if (isOpen) close(); });

  /* ---------- Retour du formulaire ----------
     Sur l'accueil, la newsletter et le popup sont deux formulaires « customer » :
     Shopify rend form.posted_successfully? / form.errors dans LES DEUX après
     l'envoi de l'un ou de l'autre. Le popup ne traite donc le retour comme le
     sien que si son propre formulaire vient d'être envoyé dans cet onglet
     (KEY_SUBMIT, posé au submit, valable SUBMIT_MAX_MS, consommé à chaque
     chargement). Dans ce cas, les messages de la newsletter (même retour
     serveur) sont masqués ; sinon, le retour appartient à la newsletter et le
     popup l'ignore. Sans aucun stockage, impossible de distinguer : on garde
     l'ancien comportement (retour attribué au popup, le code n'est jamais
     perdu). */
  var form = root.querySelector('form');
  if (form) form.addEventListener('submit', function () { setItem(KEY_SUBMIT, String(Date.now())); });
  var submittedAt = parseInt(getItem(KEY_SUBMIT), 10);
  removeItem(KEY_SUBMIT);
  var fromPopup = !sessionStore || (submittedAt > 0 && Date.now() - submittedAt >= 0 && Date.now() - submittedAt < SUBMIT_MAX_MS);
  var posted = !!root.querySelector('[data-tp-promo-posted]');
  var errorEl = root.querySelector('.tp-promo__error');

  if (fromPopup && (posted || errorEl)) {
    Array.prototype.forEach.call(document.querySelectorAll('.tp-newsletter__message'), function (m) { m.hidden = true; });
  }

  /* 1) Inscription réussie via le popup : mémoriser le code, ouvrir la vue code (modale). */
  if (posted && fromPopup) {
    setItem(KEY_CODE, '1', true);
    removeItem(KEY_DISMISSED, true);
    setItem(KEY_STATE, 'shown');
    open('success');
    return;
  }

  /* 1 bis) Erreur serveur sur le formulaire du popup : le rouvrir sur la vue
     formulaire pour que le message (role="alert") soit visible. */
  if (errorEl && fromPopup) {
    setItem(KEY_STATE, 'shown');
    open('form');
    return;
  }

  /* Retour qui n'appartient pas au popup (newsletter) : vue formulaire
     propre, sans le message de la newsletter, et pas d'auto-ouverture sur
     la page qui confirme l'inscription newsletter. */
  if (posted || errorEl) {
    if (errorEl) errorEl.parentNode.removeChild(errorEl);
    showView('form');
    refreshReminders();
    return;
  }

  /* 2) Déjà ouvert / fermé dans cette session, refusé il y a moins de
     DISMISS_DAYS jours, ou déjà inscrit : rappels seulement. */
  if (getItem(KEY_STATE) || hasCode() || dismissedRecently()) {
    refreshReminders();
    return;
  }

  /* 3) Armement : N secondes OU N % de scroll, le premier des deux. */
  var delayMs = (parseInt(root.dataset.delay, 10) || 10) * 1000;
  var scrollRatio = (parseInt(root.dataset.scroll, 10) || 35) / 100;
  var armed = true;
  var timer = null;

  /* ---------- Bandeau cookies : observé, jamais modifié ---------- */
  var cookieBanner = document.getElementById('tpCookieBanner');
  var cookieObserver = null;

  function cookieBannerVisible() {
    return !!(cookieBanner && cookieBanner.classList.contains('is-visible'));
  }

  function waitForCookieDecision() {
    if (cookieObserver || !cookieBanner || !('MutationObserver' in window)) return;
    cookieObserver = new MutationObserver(function () {
      if (cookieBannerVisible()) return;
      cookieObserver.disconnect();
      cookieObserver = null;
      window.clearTimeout(timer);
      timer = window.setTimeout(fire, COOKIE_GRACE_MS);
    });
    cookieObserver.observe(cookieBanner, { attributes: true, attributeFilter: ['class'] });
  }

  function disarm() {
    armed = false;
    window.clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    if (cookieObserver) { cookieObserver.disconnect(); cookieObserver = null; }
  }

  function fire() {
    if (!armed) return;
    if (cookieBannerVisible()) {
      window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      waitForCookieDecision();
      return;
    }
    /* Panier, recherche ou menu mobile ouverts : jamais deux couches, nouvel essai plus tard. */
    if (otherLayerOpen()) {
      window.clearTimeout(timer);
      timer = window.setTimeout(fire, delayMs);
      return;
    }
    disarm();
    setItem(KEY_STATE, 'shown');
    open('form');
  }

  function onScroll() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    if (window.scrollY / max >= scrollRatio) fire();
  }

  timer = window.setTimeout(fire, delayMs);
  window.addEventListener('scroll', onScroll, { passive: true });
  refreshReminders();
})();

/* ===================== F02 (QA 11/10/2026) =====================
   Garde anti-recouvrement generique : le teaser « -10 % de bienvenue » et la
   pilule « Mon code » sont fixes en bas a gauche. A chaque defilement /
   redimensionnement, on regarde ce qui se trouve SOUS leur zone (marge de
   securite de 12 px). S'il y a un element actionnable (lien, bouton, champ,
   pastille...), le rappel est masque (classe is-covering) jusqu'a ce que la
   zone soit libre. Priorite : CTA > teaser. Complete la regle existante du
   heros (is-yielding) sans la remplacer. Aucune donnee, aucun stockage. */
(function () {
  'use strict';
  var els = ['tpPromoTeaser', 'tpPromoCodePill']
    .map(function (id) { return document.getElementById(id); })
    .filter(Boolean);
  if (!els.length || typeof document.elementsFromPoint !== 'function') return;

  var ACTION = 'a[href], button, input, select, textarea, summary, label, [role="button"], [role="link"], [role="tab"]';
  var MARGIN = 12;
  var boxes = {};
  var raf = 0;

  function isOwn(node) {
    for (var i = 0; i < els.length; i++) { if (els[i] === node || els[i].contains(node)) return true; }
    return false;
  }

  function actionUnder(x, y) {
    if (x < 0 || y < 0 || x > window.innerWidth || y > window.innerHeight) return false;
    var stack = document.elementsFromPoint(x, y);
    for (var i = 0; i < stack.length; i++) {
      var node = stack[i];
      if (isOwn(node)) continue;
      if (node === document.documentElement || node === document.body) return false;
      var action = node.closest(ACTION);
      return !!(action && !action.closest('[data-tp-promo]'));
    }
    return false;
  }

  function check() {
    raf = 0;
    els.forEach(function (el) {
      if (el.hidden || getComputedStyle(el).display === 'none') {
        el.classList.remove('is-covering');
        return;
      }
      /* visibility:hidden conserve la boite : la zone reste mesurable. */
      var r = el.getBoundingClientRect();
      if (r.width && r.height) boxes[el.id] = { l: r.left, t: r.top, r: r.right, b: r.bottom };
      var b = boxes[el.id];
      if (!b) return;
      var xs = [b.l - MARGIN, (b.l + b.r) / 2, b.r + MARGIN];
      var ys = [b.t - MARGIN, (b.t + b.b) / 2, b.b + MARGIN];
      var hit = false;
      for (var i = 0; i < xs.length && !hit; i++) {
        for (var j = 0; j < ys.length && !hit; j++) { hit = actionUnder(xs[i], ys[j]); }
      }
      el.classList.toggle('is-covering', hit);
    });
  }

  /* Verification immediate, puis deux verifications differees : les cartes et
     boutons apparaissent souvent avec une animation (revelation au defilement),
     un controle unique au moment du scroll peut arriver trop tot. */
  var trail1 = 0, trail2 = 0;
  function schedule() {
    if (!raf) raf = window.requestAnimationFrame(check);
    window.clearTimeout(trail1); window.clearTimeout(trail2);
    trail1 = window.setTimeout(check, 450);
    trail2 = window.setTimeout(check, 1200);
  }
  /* Filet de securite tant que le rappel est affichable : un controle leger
     (9 points) toutes les 1,5 s, uniquement onglet visible. */
  window.setInterval(function () {
    if (document.visibilityState !== 'visible') return;
    for (var i = 0; i < els.length; i++) { if (!els[i].hidden) { check(); return; } }
  }, 1500);

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', function () { boxes = {}; schedule(); });
  window.addEventListener('load', schedule);
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(schedule);
    els.forEach(function (el) { mo.observe(el, { attributes: true, attributeFilter: ['hidden', 'class'] }); });
  }
  schedule();
})();
